import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MediaCardComponent } from './media-card.component';
import { WmIconModule } from '../icon/index';
import { WmTransitionModule } from '../transition/index';
import { WmButtonModule } from '../button/index';
import { WmCardModule } from '../card/index';
import { WmMenuModule } from '../menu/index';
import { WmCaptionModule } from '../caption/index';
import { WmTagModule } from '../tag/index';

@NgModule({
	declarations: [MediaCardComponent],
	imports: [
		CommonModule,
		WmTransitionModule,
		WmIconModule,
		WmButtonModule,
		WmCardModule,
		WmMenuModule,
		WmCaptionModule,
		WmTagModule
	],
	exports: [MediaCardComponent]
})
export class WmMediaCardModule {}
